import { render, staticRenderFns } from "./DeliveryOptionList.vue?vue&type=template&id=1310607d&scoped=true&"
import script from "./DeliveryOptionList.vue?vue&type=script&lang=js&"
export * from "./DeliveryOptionList.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOptionList.vue?vue&type=style&index=0&id=1310607d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1310607d",
  null
  
)

export default component.exports